import React from 'react'
import Verification from '../../../modules/ELearning/Course/Enroll/Verification'

const ELearningCourseVerificationPage = () => {
  return <Verification />
}

export default ELearningCourseVerificationPage
